import { formatUserFacingError } from '@/lib/errors'
import { useState, useEffect } from 'react'
import { ticketingService } from '../services/ticketing.service'
import type { EventDocument } from '@/types'

export function useEvents() {
  const [events, setEvents] = useState<Array<EventDocument & { id: string }>>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    ticketingService
      .getPublishedEvents()
      .then(setEvents)
      .catch((err: unknown) =>
        setError(formatUserFacingError(err, 'Failed to load events')),
      )
      .finally(() => setLoading(false))
  }, [])

  return { events, loading, error }
}
